import { render, staticRenderFns } from "./newMaterialDetail.vue?vue&type=template&id=03d27e85&scoped=true&"
import script from "./newMaterialDetail.vue?vue&type=script&lang=js&"
export * from "./newMaterialDetail.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialDetail.vue?vue&type=style&index=0&id=03d27e85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d27e85",
  null
  
)

component.options.__file = "newMaterialDetail.vue"
export default component.exports